(function () {
    "use strict";

    var configuration = window.nadex.marketing.analytics.sitecatConfig.getSiteConfig();
    var visitor = Visitor.getInstance(configuration.organisationId, {
         trackingServer: configuration.trackingDomain,
         trackingServerSecure: 's' + configuration.trackingDomain
    });
}());